export default __webpack_public_path__ + "0245f5cae4e808678ab5ccf1bbb43f7f.webp";